<template>
  <div class="accountSecurity">
    <header-item
      :title-array="titleArray"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <div class="formClass">
      <div v-if="isShow && !columns.length" class="account-security-title">
        <p>亲爱的玩家，您当前的雷霆账号没有关联游戏</p>
      </div>
      <!-- step one -->
      <div v-if="columns.length && active === 0" class="account-security-one">
        <div class="account-security-title">
          <p>为了保障您的账户安全，在新设备上首次使用账号密码登录时，推荐通过短信验证码进行额外的安全验证。以下是各游戏的具体设置情况：</p>
        </div>
        <ul class="account-security-list">
          <li>
            <p>游戏名</p>
            <p>是否开启短信验证</p>
          </li>
          <li v-for="(item, i) in columns" :key="i" :class="item.status === 0 ? 'highlight__red' : ''">
            <p>{{ item.gameName }}</p>
            <p>{{ item.status === 1 ? '是' : '否' }}</p>
          </li>
        </ul>
        <van-button type="primary" size="normal" color="#606DE2" plain round @click="active = 1">设置</van-button>
      </div>
      <!-- step two -->
      <div v-if="columns.length && active === 1" class="account-security-two">
        <div class="account-security-title">
          <p>请选择开启短信验证的游戏：</p>
        </div>
        <ul class="account-security-list">
          <li>
            <p>游戏名</p>
            <p>是否开启短信验证</p>
          </li>
          <li v-for="(item, i) in columnsModify" :key="i" :class="item.status === 1 && item.safeResult.length ? '' : 'highlight__red'">
            <van-checkbox-group v-model="item.safeResult">
              <van-checkbox
                :name="item.game"
                shape="square"
                checked-color="#606DE2"
              >{{ item.gameName }}</van-checkbox>
            </van-checkbox-group>
            <p>{{ item.status === 1 && item.safeResult.length ? '是' : '否' }}</p>
          </li>
        </ul>
        <van-form @submit="handleSubmit">
          <van-field
            v-model="securityGame.code"
            :label="`将发短信至绑定手机号：${encryptedPhone}`"
            maxlength="6"
            style="border-radius: 16px;"
            :rules="rules.codeRules"
            placeholder="请输入验证码"
          >
            <template #button>
              <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode('MODIFY_PWD_LOGIN_CODE_VERIFY')">{{ timeMsg }}</p>
              <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
            </template>
          </van-field>
          <p class="reg_p">*如果1分钟内没有收到验证码请重新获取</p>
        </van-form>
        <div class="account-security-tips">
          <h4>温馨提示：</h4>
          <p>每日可操作3次，当前为开启状态。功能关闭后您的的账号在新设备或者长久不登录的设备使用账密登录，将不再需要短信校验，存在账号被盗风险，为保障您的账号安全，请谨慎操作。</p>
        </div>
        <div class="account-security-btn">
          <van-button size="normal" color="#606DE2" plain round @click="active = 0">取消</van-button>
          <van-button type="primary" size="normal" color="#606DE2" round @click="handleSubmit">确认</van-button>
        </div>
      </div>
      <!-- end -->
    </div>
  </div>
</template>
<script>
import rules from '@/mixins/validator'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import { throttle } from '@/utils/debounce.js'
import headerItem from '@/views/accountCenter/common/header'
import * as api from '@/api/account-center-manage/accountSecurity'

export default {
  name: 'AccountSecurity',
  components: {
    headerItem
  },
  mixins: [sendCode],
  data() {
    return {
      rules: rules,
      isShow: false,
      backFlag: true,
      active: 0,
      columns: [],
      columnsModify: [],
      gameList: [],
      preIndex: [],
      titleArray: ['账号安全', '首页', '账号管理中心', '账号安全'],
      currentIndex: 0,
      securityGame: {
        code: ''
      },
      encryptedPhone: '',
      userInfo: {}
    }
  },
  created() {
    this.encryptedPhone = window.ltlAccount.isLogin() ? window.ltlAccount.getLoginState()?.phone : ''
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.accountSecurity').className = ['accountSecurity accountSecurityH5 accountCommonH5']
    } else {
      document.querySelector('.accountSecurity').className = ['accountSecurity accountSecurityWeb accountCommonWeb']
    }
    this.getDetail()
  },
  methods: {
    navBarClick() {
      this.backFlag = false
      if (this.preIndex.length != 0) {
        this.currentIndex = this.preIndex.pop()
      } else {
        this.$router.go(-1)
      }
    },
    getDetail() {
      this.$loading.show()
      api.account_security_detail().then(res => {
        this.isShow = true
        this.$loading.hide()
        if (res.status == 0) {
          this.columns = res.data.gameList
          this.columnsModify = []
          res.data.gameList.forEach((el) => {
            if (el.status === 1) {
              this.columnsModify.push({
                ...el,
                safeResult: [el.game]
              })
            } else {
              this.columnsModify.push({
                ...el,
                safeResult: []
              })
            }
          })
        }
      }, () => {
        this.$loading.hide()
      })
    },
    getCode(type) {
      ltCaptcha((captcha) => {
        this.$tool.sendCode({
          type,
          captcha
        }).then((res) => {
          this.startTimer()
        })
      })
    },
    handleSubmit: throttle(function() {
      if (!this.securityGame.code) {
        this.$msg('短信验证码不能为空')
        return
      }
      const gameList = []
      this.columnsModify.forEach((el) => {
        if (el.safeResult.length) {
          // 开启短信验证
          gameList.push({
            game: el.game,
            status: 1
          })
        } else {
          // 关闭短信验证
          gameList.push({
            game: el.game,
            status: 0
          })
        }
      })
      api.account_security_modify({
        code: this.securityGame.code,
        gameList
      }).then((res) => {
        if (res.status === 0) {
          this.getDetail()
          this.active = 0
        }
      })
    }, 300)
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';

// h5
  .accountSecurityH5 {
    // padding-bottom: 0.5rem;
    border-radius: 10px;
    font-size: 0.25rem;
    background: #f7f8fa;
    // position: relative
    z-index 99

    ::v-deep .van-button--disabled {
      cursor: not-allowed;
      opacity: 1;
      background: #b8beee !important;
      border-color: #b8beee !important;
    }

    .formClass {
      padding: 0.3rem .4rem;
      position relative

      .account-security {
        &-title {
          font-size 0.28rem
          line-height 1.5
          color: #5D5D5D
        }
        &-list {
          padding: 0.24rem 0
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.12rem 0
            background-color: #FBFCFD
            p {
              width: 50%
              color: #5D5D5D
              font-size 0.26rem
              line-height 1.5
              padding: 0 0.24rem
              box-sizing: border-box
            }
          }
          .van-checkbox:nth-child(2n),
          li:nth-child(2n+1) {
            background-color: #ECECEC
          }
          li.highlight__red {
            ::v-deep .van-checkbox__label,
            p {
              color: #FF3D3D
            }
          }
        }
        &-tips {
          h4 {
            font-size 0.28rem
            color: #EB8D12
            line-height: 2
          }
          p {
            color: #878787
            font-size 0.26rem
            line-height 1.5
          }
        }
        &-two {
          .account-security-list {
            ::v-deep .van-checkbox-group {
              width 50%
              box-sizing: border-box
            }
            .van-checkbox {
              width: 100%
              text-align: center
              color: #5D5D5D
              font-size 0.3rem
              line-height 1.5
              min-height: .63rem
              padding: 0 0 0 0.24rem
              ::v-deep .van-checkbox__label {
                font-size 0.26rem
              }
            }
          }
        }
        &-btn {
          width: 100%
          padding: 0;
          box-sizing: border-box
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap
        }
      }
      .van-form {
        width 100%
        padding: 0.24rem 0 0.6rem
        box-sizing: border-box
        .van-cell {
          padding-left: 0
          padding-right: 0
          flex-wrap: wrap
        }
        ::v-deep .van-field__label {
          width: 100%
          display: block
          padding-left: 0.24rem
          box-sizing: border-box
        }
        .reg_p {
          color: #878787
          font-size 0.26rem
          padding-top: .12rem
        }
      }
      .van-button {
        display: block
        width: 3.12rem
        margin: 0.44rem auto
      }
    }
  }

// web
  .accountSecurityWeb {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;

    .formClass {
      margin: 0.5rem auto;
      padding: 0 .8rem;
      box-sizing: border-box

      .account-security {
        &-title {
          color: #656565
          font-size 0.32rem
          line-height 1.5
        }
        &-list {
          padding: 0.36rem 0 0
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.12rem 0
            p {
              width: 50%
              text-align: center
              color: #5D5D5D
              font-size 0.3rem
              line-height 1.5
            }
          }
          .van-checkbox:nth-child(2n),
          li:nth-child(2n+1) {
            background-color: #ECECEC
          }
          li.highlight__red {
            ::v-deep .van-checkbox__label,
            p {
              color: #FF3D3D
            }
          }
        }
        &-btn {
          width: 100%
          padding: 0 1rem;
          box-sizing: border-box
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap
        }
        &-two {
          .account-security-list {
            width: 100%
            ::v-deep .van-checkbox-group {
              width 50%
              padding: 0 0 0 0.48rem
              box-sizing: border-box
            }
            .van-checkbox {
              text-align: center
              color: #5D5D5D
              font-size 0.3rem
              line-height 1.5
              min-height: .69rem
            }
          }
        }
        &-tips {
          h4 {
            font-size 0.28rem
            color: #EB8D12
            line-height: 2
          }
          p {
            color: #878787
            font-size 0.26rem
            line-height 1.5
          }
        }
      }
      .van-form {
        width 60%
        padding: 0.24rem 0 0.6rem
        .van-cell {
          padding-left: 0
          padding-right: 0
        }
        ::v-deep .van-field__label {
          width: 80%
        }
        .reg_p {
          color: #878787
          font-size 0.26rem
        }
      }
      .van-button {
        display: block
        width: 4rem
        margin: 0.96rem auto
      }
    }
  }
</style>
